import styled from "styled-components";
import { getPartnerConfig } from "utils/partner";
import { formatCurrency } from "utils/string";
import { Heading } from "./Text";
import Tile from "./Tile";
import UILabel from "./UILabel";

const Wrapper = styled(Tile)`
  display: flex;
  gap: 12px;
  flex-direction: column;
`;

const Main = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 144px;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Amount = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Card = styled.img`
  width: 100%;

  border-radius: 6px;
`;

type Props = {
  name: string;
  accountNumber?: string;
  amount: number;
  amountLabel?: string;
  cardImageName?: string;
  children?: React.ReactNode;
};

const AccountCard: React.FC<Props> = ({
  name,
  accountNumber,
  amount,
  amountLabel = "Current balance",
  cardImageName,
  children,
}) => {
  const partner = getPartnerConfig();

  return (
    <Wrapper size="lg">
      <Main>
        <Info>
          <UILabel.Large>
            {name} {accountNumber && <>&hellip;{accountNumber.slice(-4)}</>}
          </UILabel.Large>

          <Amount>
            <UILabel.Medium>{amountLabel}</UILabel.Medium>
            <Heading.H3 color="primary">
              {formatCurrency(amount, true)}
            </Heading.H3>
          </Amount>
        </Info>
        <div>
          {cardImageName && (
            <Card src={`/partner/${partner.slug}/${cardImageName}.svg`} />
          )}
        </div>
      </Main>

      {children}
    </Wrapper>
  );
};

export default AccountCard;
